






























import { Vue, Prop, Component } from 'vue-property-decorator';
import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import TerminalComponent from '@/components/Pages/MobileEstimate/Terminal.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';

import { MobileConfig } from '@/data/mobileConfig';
import { Terminal } from '@/data/mobile/terminal';

@Component({
  components: {
    ListItem,
    UnorderedList,
    TerminalComponent,
  },
})
export default class Terminals extends Vue {
  @Prop() mobile!: MobileConfig;
  namespace = 'mobile';

  get planTotal(): number {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'plans',
    });
  }

  get terminalTotal(): number {
    return this.$store.getters[`${this.namespace}/count`]({
      stateKey: 'terminals',
    });
  }

  get selectedTerminals(): Terminal[] {
    return this.mobile.terminals.filter((terminal: Terminal) => {
      if (terminal.attention == undefined) {
        return false;
      } else {
        const count = this.$store.getters[`${this.namespace}/count`]({
          stateKey: 'terminals',
          id: terminal.id,
        });
        return count > 0;
      }
    });
  }
}
